@if (shouldShowDepositsBanner$ | async) {
  <div class="banner_card card">
    <div class="banner_card-icon">
      <svg-inline [src]="'/assets/images/new-deposit-now-icon.svg'" [alt]="'deposit' | translate" />
    </div>
    <div class="banner_card-header">{{ "dashboard_banner_deposit_now_title" | translate }}</div>
    <div class="banner_card-body">{{ "dashboard_banner_deposit_now_subtitle" | translate }}</div>
    <div class="banner_card-close">
      <a class="btn btn-primary" (click)="deposit()">
        {{ "deposit_now" | translate }}
      </a>
    </div>
  </div>
}
